import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetItems(payload) {
    // console.log("payload", payload);
    // let query = "";
    // if (payload.cinema_code) {
    //   query += `&cinema_code=${payload.cinema_code}`;
    // }
    // if (payload.filter_id) {
    //   query += `&filter_id=${payload.filter_id}`;
    // }
    // if (payload.date) {
    //   query += `&date=${payload.date}`;
    // }

    return Api().get(`${API_VERSION}/webapp/items`, { params: payload });
  },
  GetItemFilters() {
    return Api().get(`${API_VERSION}/webapp/items/filters`);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/ItemsService.js